import { useState } from 'react';
import { Users } from 'lucide-react';
import Lpp from "./Hublang/Penagihan/Lpp";
import { Tunggakan } from "./Hublang/Penagihan/TTunggakan";
import { Perlunasan } from "./Hublang/Penagihan/Perlunasan";
import { Pembatalan } from "./Hublang/Penagihan/Pembatalan";
import { Rlpp } from "./Hublang/Penagihan/Rlpp";

export default function DashboardPenagihan() {
  const [menuStatus, setMenuStatus] = useState("tunggakan");
  

  return (
    <>
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
        <div className="max-w-8xl mx-auto">
          {/* Header */}
          <div className="mb-8">
            <div className="flex items-center mb-4">
              <Users className="w-8 h-8 text-blue-600 mr-3" />
              <div>
                <h1 className="text-3xl font-bold text-gray-800">Loket</h1>
                {/* <p className="text-gray-600">Kelola data karyawan dan informasi kontrak</p> */}
              </div>
            </div>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-4 md:space-y-0">
              <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4">
                <button
                  onClick={() => setMenuStatus("tunggakan")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'tunggakan' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'tunggakan' ? 'blue' : 'gray'}-200 transition-colors`}
                >
                  TUNGGAKAN
                </button>

                <button 
                  onClick={() => setMenuStatus("perlunasan")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'perlunasan' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'perlunasan' ? 'blue' : 'gray'}-200 transition-colors`}>
                  PERLUNASAN
                </button>

                <button 
                  onClick={() => setMenuStatus("pembatalan")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'pembatalan' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'pembatalan' ? 'blue' : 'gray'}-200 transition-colors`}>
                  PEMBATALAN
                </button>

                <button 
                  onClick={() => setMenuStatus("lpp")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'lpp' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'lpp' ? 'blue' : 'gray'}-200 transition-colors`}>
                  LPP
                </button>

                <button 
                  onClick={() => setMenuStatus("rlpp")}
                  className={`flex items-center px-4 py-2 text-gray-700 bg-${menuStatus === 'rlpp' ? 'blue' : 'gray'}-100 rounded-lg hover:bg-${menuStatus === 'rlpp' ? 'blue' : 'gray'}-200 transition-colors`}>
                  RLPP
                </button>
              </div>
            </div>
          </div>

          { menuStatus == "lpp" && <Lpp />}
          { menuStatus == "tunggakan" && <Tunggakan />}
          { menuStatus == "perlunasan" && <Perlunasan />}
          { menuStatus == "pembatalan" && <Pembatalan />}
          { menuStatus == "rlpp" && <Rlpp />}


        </div>
      </div>
    </>
  )
}
